<script>


// https://www.npmjs.com/package/country-flag-emoji-json
// https://github.com/matiassingers/emoji-flags/blob/master/data.json
// sprites: https://cdn.jsdelivr.net/gh/Yerikmiller/yerikmiller.github.io/countries_flags_emoji/sprites.svg

import {clickOutside} from '../../libraries/clickOutside';
import { onMount } from 'svelte';
import { countries_importer } from '../../libraries/countries_importer';
import {FecthLocationIpAndSprites} from './InternationalNumber/FecthLocationIpAndSprites'
    import { parseIniString } from '../../libraries/parseIniString';


export let ClassInputs = "formElements";
export let styles_container = "";
export let ClassButton = "";
export let classTexts = ""
export let Results = function(){};
export let placeholder_phone = window?.ContentsAll?.ctn_Y2JFVr ?? "Celular";
export let placeholder_Search = window?.ContentsAll?.ctn_vsFs ?? "Buscar";
export let names = {
    dial: "dial",
    phone: "phone",
    country: "country",
};

export let html_required = false;

export let valid_phone = null;
/**
 * @type {String}
 */
export let selected_code = "CO";
export let selected_dial = "+57";
export let selected_country = "Colombia";
export let selected_value = "";
export let has_static_dial = true;
export let check_on_mount = true;

/**
 * Funcion que se ejecuta cuando se le da click al boton trigger para cambiar el dial y el país
 */
export let on_change_trigger = () => {};

if(selected_code === null){selected_code = "CO"}
if(selected_dial === null){selected_dial = "+57"}
if(selected_country === null){selected_country = "Colombia"}
if(selected_value === null){selected_value = ""}



let loaded = false;
let countries = [];
let countries_backup = [];
let sprites = false;
let locationData = {};
let disabled = "disabled=''";
let isValid = "default";
let InputElement;
let input_phone = null;

$: {
    if(selected_code){
        countries_importer((Countries)=>{
            /**
             * On passing code3 ISO3, conveert to iso2
            */
            if(selected_code.length === 3){
                Countries.forEach((country)=>{
                    if(country.iso3 === selected_code){
                        selected_code = country.iso2
                    }
                })
            }    
        })
    }
}

FecthLocationIpAndSprites.get().then(async (data)=>{
    locationData = data.locationData;
    countries = data.countries;
    sprites = data.sprites;
    countries_backup = data.countries_backup

    if(has_static_dial){
        const loc_result = data?.locationData ?? null;
        if(loc_result !== null){
            try {
                locationData = parseIniString(data.locationData);
                selected_code = locationData.loc;
            } catch (error) {
                selected_code = "CO"
            }
        }else{
            try {
                // if cgi/trace (cloudflare) fails try to load location by timezone.
                selected_code = await FecthLocationIpAndSprites.getByTimezone()
            } catch (error) {
                selected_code = "CO"
            }
        }

        if (typeof selected_code === "undefined" || selected_code === null) {
            selected_code = "CO"
        }
        let country = countries.find(( country )=>{
            if(country.c === selected_code){
                country = country.d;
                return country;
            }
        });
        selected_dial = country.d; 
        selected_country = country.c;
    } else if (selected_dial) {
        // Sincronizar selected_code desde selected_dial para que la bandera coincida
        const matchingCountry = countries.find(c => c.d === selected_dial);
        if (matchingCountry && matchingCountry.c !== selected_code) {
            selected_code = matchingCountry.c;
            selected_country = matchingCountry.n;
        }
    }

    loaded = true;
    disabled = "";
})

function checkNumber(input){
    if(input === null){ return; }
    let numericValue = input?.value?.replace(/[^0-9]/g, '');
    input.value = numericValue;
    let value = input.value.split(selected_dial).join("");
    if (value === "") {
        isValid = "default";
        return;
    }
    let results = libphonenumber.isValidPhoneNumber(selected_dial+value, selected_dial);
    Results(results);
    if(results === false){
        isValid = "is-danger-color";
        input.dataset.valid = false;
        valid_phone = false;
    }else{
        isValid = "is-success-color";
        input.value = value;
        input.dataset.valid = true;
        valid_phone = true;
    }
    return results;
}

let input;
let dropdown;
let trigger = null;

$: {
    if(trigger !== null){        
        trigger.addEventListener("click", ()=>{
            dropdown.classList.toggle("is-active");
            if(dropdown.classList.contains("is-active")){
                clickOutside([dropdown], (destroy)=>{
                    if(dropdown === null){
                        destroy();
                        return;
                    }
                    dropdown.classList.remove("is-active");
                    destroy();
                })
            }
        })
    }
}

function selectCode(country){
    selected_code = country.c;
    selected_country = country.n;
    selected_dial = country.d;
    dropdown.classList.remove("is-active");

    checkNumber(input_phone);
    on_change_trigger({selected_code, selected_country, selected_dial})
}

function international_number_filter(){
    if (InputElement.value === "") {
        countries_backup = countries;
    }else{
        countries_backup = countries.filter((country)=>{
            if (country.n.toLowerCase().includes(InputElement.value.toLowerCase())) {
                return country;
            }
        });
    }
}

function simpleNumberValidator(value) {
    value = parseInt(value, 10)
    let is_valid_number = false;
    if (value !== "" && value !== null && value !== "undefined") {
        if (typeof value === 'number' && !isNaN(value)) {
            if (value >= 0) {
                is_valid_number = true;
                return is_valid_number;
            }
        }
    }
    return is_valid_number;
}
onMount(()=>{
    if (check_on_mount) {
        setTimeout(() => {
            if(simpleNumberValidator(input_phone?.value)){
                checkNumber(input_phone);
            }
    
            if(selected_dial !== "+57" && simpleNumberValidator(input_phone?.value)){
                checkNumber(input_phone);
            }
        }, 1500);
    }
})

</script>
{#if sprites !== false}
    {@html sprites}
{/if}
<international-number-input class="field has-addons flex-center" style="{styles_container}">
    <div class="control">
        <div class="dropdown" bind:this="{dropdown}">
            <div class="dropdown-trigger">
                <button {disabled}  bind:this="{trigger}" type="button" class="button has-not-animated is-outlined is-marginless button-trigger button-open-codes {ClassButton}" aria-haspopup="true" aria-controls="dropdown-menu">
                    <span class="is-size-7 is-flex is-align-items-center">
                        <span class="icon is-small">
                            <svg class="icon-flags icon-flags-{selected_code}"><use xlink:href="#icon-flags-{selected_code}"></use></svg>
                        </span>
                        <span class="intl-selected-dial {classTexts}">({selected_dial})</span>
                        <span class="icon is-small {classTexts}">
                            <i class="icon-tripod-arrow-small-down font-size-9 arrow-angle"></i>
                        </span>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu has-shadow custom-scrollbar-gray" style="padding-top: 0 !important; margin-top: 5px !important;" id="dropdown-menu" role="menu">
                <div class="dropdown-content" style="padding-top: 0 !important;">
                    <div class="search-positioner">
                        <international-number-search class="search-container full-width">
                            <input type="text" bind:this={InputElement} on:keydown={
                                (event)=>{
                                    if( event.keyCode == 13 ) {
                                        event.preventDefault();
                                        return false;
                                    }
                                }
                            } on:input={
                                ()=>{
                                    international_number_filter()
                                }
                            } class="search-input formsElements" name="toSearch"  placeholder={placeholder_Search}>
                            <span class="icon-search">
                                <i style="font-size: 20px;" class="icon-tripod-search"></i>
                            </span>
                        </international-number-search>
                    </div>
                    {#each countries_backup as country}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <span aria-hidden on:click={()=>{ selectCode(country) }} data-value="{country.c}" style="text-decoration:none" class="dropdown-item pointer img-flags-container">
                            <svg class="icon-flags icon-flags-{country.c}"><use xlink:href="#icon-flags-{country.c}"></use></svg>
                            <span class="intl-dial-number-list">
                                ({country.d}) {country.n}
                            </span>
                        </span>
                    {/each}
                </div>
            </div>
        </div>
    </div>
    <p class="control international-number-element {loaded === false ? "is-loading" : ""}">
        <input bind:this={input_phone} on:input="{()=>{
            checkNumber(input_phone)
        }}" on:click={()=>{
            checkNumber(input_phone)
        }} {disabled} class="input {isValid} phone-input {ClassInputs} {classTexts}" inputmode="numeric" name="{names.phone}" type="tel" placeholder= {placeholder_phone} bind:value="{selected_value}" required={html_required}>
        <input class="{ClassInputs}" type="hidden" name="{names.dial}" value="{selected_dial}">
        <input class="{ClassInputs}" type="hidden" name="{names.country}" value="{selected_code}">
    </p>    
</international-number-input>
<style>
    .is-danger-color, .is-danger-color:focus{
        border: 1px solid var(--color-danger) !important;
    }
    .is-success-color, .is-success-color:focus{
        border:1px solid var(--color-green);
    }
    .default{
        border: 1px solid var(--color-mid-grey) !important;
    }
    .img-flags-container{
        display: flex;
        align-items: center;
    }
    .icon-flags {
        display: inline-block;
        width: 1.45em;
        height: 1.45em;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
        padding-top: 0px;
        margin-right: 4px;
    }
    .button-open-codes{
        border: 1px solid var(--color-lightMidGrey);
        max-height: 38px;
    }
    .dropdown-menu{
        max-height: 300px;
        min-width: 280px;
        overflow-y: auto;
        border-radius: 8px;
    }
    :global(.sv) .button-trigger{
        border: 1px solid var(--color-lightMidGrey);
        padding: 18px;
        padding-right: 8px !important;
    }
    .international-number-element{
        width: 100%;
    }
    .international-number-element .input{
        width: 100%;
    }
    .button-trigger:focus{
        box-shadow: none;
    }
    .arrow-angle{
        position: relative;
        left: -3px;
    }
    international-number-input{
        width: 100%;
    }
    .button-trigger{
        padding: 0.625rem 1.25rem;
        border: 1px solid var(--color-mid-grey);
    }
    
    
    /* seach styles */
    
    .search-positioner{
        padding: 0.625rem;
        background: white;
        z-index: 1000;
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
    }
    
    .search-container{
        position: relative;
    }
    
    .search-container input{
        padding-right: 30px;
    }
    
    .search-input{
        border: 1px solid var(--color-mid-grey);
        border-radius: 8px;
        opacity: 1;
        outline: none;
        width: 100%;
        height: 32px;
    }
    
    .search-input::placeholder{
        color: var(--color-mid-grey);
        font: normal normal normal 14px/20px Montserrat;
        opacity: 1;
        width: 49px;
        height: 18px;
        transform: translateX(8px);
    }
    
    .icon{
        display: flex;
        user-select: none;
    }
    
    .icon-search{
        position: absolute;
        display: block;
        top: 0px;
        right: 7px;
        user-select: none;
    }
    </style>